<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="activeRules" :model="form" label-position="right" size="small" label-width="140px">
      <!-- BUG-2026-735208：编辑态凭据框不回填列表带回的星号（那是脱敏值），留空 = 不修改；后端同样把空/星号当"没改" -->
      <el-alert
        v-if="form.id"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom:12px"
        title="凭据类字段（msgKey / ruanCertificate / appKey / appSecret / 商户号 / 机构号 / 应用ID / 公钥 / 私钥）出于安全不回显；不修改请留空，填写即覆盖。"
      />
      <el-form-item label="城市公司" prop="cityIds" class="width100">
        <el-select v-model="form.cityIds" placeholder="请选择城市公司" filterable size="small" clearable>
          <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用友账套配置" class="width100" style="font-blod: 600"></el-form-item>
      <el-form-item label="msgKey" prop="msgKey">
        <el-input v-model="form.msgKey" :placeholder="form.id ? '不修改请留空' : '请输入msgKey'" />
      </el-form-item>
      <el-form-item label="ruanCertificate" prop="ruanCertificate">
        <el-input v-model="form.ruanCertificate" :placeholder="form.id ? '不修改请留空' : '请输入ruanCertificate'" />
      </el-form-item>
      <el-form-item label="authorisationUrl" prop="authorisationUrl">
        <el-input v-model="form.authorisationUrl" placeholder="请输入authorisationUrl" />
      </el-form-item>
      <el-form-item label="appKey" prop="appKey">
        <el-input v-model="form.appKey" :placeholder="form.id ? '不修改请留空' : '请输入appKey'" />
      </el-form-item>
      <el-form-item label="appSecret" prop="appSecret">
        <el-input v-model="form.appSecret" :placeholder="form.id ? '不修改请留空' : '请输入appSecret'" />
      </el-form-item>
      <el-form-item label="是否是旧系统账套" prop="isUseOrder">
        <el-radio-group v-model="form.isUseOrder">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否教育公司用于收学费" prop="isUseEducation">
        <el-radio-group v-model="form.isUseEducation">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="通商云支付配置" class="width100"></el-form-item>
      <el-form-item label="商户号" prop="cusId">
        <el-input v-model="form.cusId" :placeholder="form.id ? '不修改请留空' : '请输入商户号'" />
      </el-form-item>
      <el-form-item label="机构号" prop="orgId">
        <el-input v-model="form.orgId" :placeholder="form.id ? '不修改请留空' : '请输入机构号'" />
      </el-form-item>
      <el-form-item label="应用ID" prop="appId">
        <el-input v-model="form.appId" :placeholder="form.id ? '不修改请留空' : '请输入应用ID'" />
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input v-model="form.version" placeholder="请输入版本号" />
      </el-form-item>
      <el-form-item label="公钥" prop="pubKey">
        <el-input v-model="form.pubKey" :placeholder="form.id ? '不修改请留空' : '请输入公钥'" />
      </el-form-item>
      <el-form-item label="私钥" prop="privateKey">
        <el-input v-model="form.privateKey" :placeholder="form.id ? '不修改请留空' : '请输入私钥'" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import yongyouConfigApi from '@/api/config/yongyouConfig'
// 列表接口按 SensitiveMaskSerializer 脱敏返回的凭据字段（******/前4位******），编辑态不回填、留空不提交
const SENSITIVE_FIELDS = ['msgKey', 'ruanCertificate', 'appKey', 'appSecret', 'cusId', 'orgId', 'appId', 'pubKey', 'privateKey']

function initFormBean() {
  const formBean = {
    // ⚠️ id 必须在这里声明（BUG-2026-273905）。Vue 2 的响应式是 data() 初始化时逐键装上去的，
    // 后来在 handleUpdate 里 `this.form.id = row.id` 新增的键**不是响应式的**，
    // 于是 computed activeRules 读 this.form.id 收集不到依赖、永远吃缓存 ——
    // 编辑态也按新增态要求 9 个凭据必填，留空提交被前端拦死、请求根本发不出去。
    // 而模板里直接读 form.id 能跟着别的依赖重渲染，所以**看起来像修好了**。
    id: null,
    cityIds: null,
    msgKey: null,
    ruanCertificate: null,
    authorisationUrl: null,
    appKey: null,
    appSecret: null,
    isUseEducation: null,
    state: 0,
    isUseOrder: 1,
    cusId: null,
    orgId: null,
    appId: null,
    version: null,
    pubKey: null,
    privateKey: null,
  }
  return formBean
}

export default {
  props: ['cityCompanyOptions'],
  data() {
    return {
      old: initFormBean(),
      form: initFormBean(),
      formVisible: false,
      formRules: {
        // cityIds: [{ required: true, message: '请选择城市公司', trigger: 'change' }],
        msgKey: [{ required: true, message: '请输入msgKey', trigger: 'blur' }],
        ruanCertificate: [{ required: true, message: '请输入ruanCertificate', trigger: 'blur' }],
        authorisationUrl: [{ required: true, message: '请输入authorisationUrl', trigger: 'blur' }],
        appKey: [{ required: true, message: '请输入appKey', trigger: 'blur' }],
        appSecret: [{ required: true, message: '请输入appSecret', trigger: 'blur' }],
        isUseEducation: [{ required: true, message: '请选择是否教育公司用于收学费', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
        cusId: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
        orgId: [{ required: true, message: '请输入机构号', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入应用ID', trigger: 'blur' }],
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        pubKey: [{ required: true, message: '请输入公钥', trigger: 'blur' }],
        privateKey: [{ required: true, message: '请输入私钥', trigger: 'blur' }],
      }
    }
  },
  computed: {
    /** 新建时凭据必填；编辑时留空 = 不修改，所以去掉这 9 项的 required（BUG-2026-735208） */
    activeRules() {
      if (!this.form.id) return this.formRules
      const rules = { ...this.formRules }
      SENSITIVE_FIELDS.forEach(k => { delete rules[k] })
      return rules
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      for (const key in initFormBean()) {
        this.form[key] = this.old[key]
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.old = initFormBean();
      this.form = initFormBean();
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.old = { ...row }
      this.resetForm()
      // BUG-2026-735208：row 里的凭据是脱敏后的星号，回填再提交就会把星号写进库（用友推送全断）。
      // 编辑态一律清空，留空 = 不修改；后端 keepSensitiveIfMasked 同样兜底。
      SENSITIVE_FIELDS.forEach(k => { this.form[k] = null })
      this.form.cityIds = +row.cityIds.replaceAll('#', '')
      this.form.id = row.id
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.cityIds = `#${params.cityIds}#`
      if (params.id > 0) {
        // 编辑：留空或仍是星号的凭据不提交，后端保留库值
        SENSITIVE_FIELDS.forEach(k => {
          const v = params[k]
          if (v == null || String(v).trim() === '' || String(v).endsWith('******')) delete params[k]
        })
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.id > 0) {
            yongyouConfigApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            yongyouConfigApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
